// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:25
import { ChoiceState_abstract } from './../abstract/SagaBase/ChoiceState_abstract';
export class ChoiceState extends ChoiceState_abstract {}
